import { parseISO } from 'date-fns';
import {
    DOCUMENT_META_TYPE,
    DOCUMENTS_META_SEPARATOR,
    DOCUMENTS_MONTH_KEYS,
    DOCUMENTS_RANGE_DASH,
} from '../constants';
import type { TDocumentsListItem, TTranslate } from '../types';

const getMonthName = (date: Date, t: TTranslate): string =>
    t(`commons.months.${DOCUMENTS_MONTH_KEYS[date.getMonth()]}`).toLowerCase();

const getYearSuffix = (date: Date, now: Date): string =>
    date.getFullYear() === now.getFullYear() ? '' : ` ${date.getFullYear()}`;

export const formatDayMonth = (isoDate: string, t: TTranslate, now: Date = new Date()): string => {
    const date = parseISO(isoDate);
    return `${date.getDate()} ${getMonthName(date, t)}${getYearSuffix(date, now)}`;
};

export const formatDayRange = (start: string, end: string, t: TTranslate, now: Date = new Date()): string => {
    const startDate = parseISO(start);
    const endDate = parseISO(end);
    const isSameMonth =
        startDate.getMonth() === endDate.getMonth() && startDate.getFullYear() === endDate.getFullYear();

    if (isSameMonth) {
        return `${startDate.getDate()}${DOCUMENTS_RANGE_DASH}${endDate.getDate()} ${getMonthName(endDate, t)}${getYearSuffix(endDate, now)}`;
    }
    return `${formatDayMonth(start, t, now)} ${DOCUMENTS_RANGE_DASH} ${formatDayMonth(end, t, now)}`;
};

export const formatDocumentMeta = (item: TDocumentsListItem, t: TTranslate, now: Date = new Date()): string => {
    const { meta } = item;
    let label: string;

    if (meta.type === DOCUMENT_META_TYPE.period) {
        label = t('documents.meta.week', { range: formatDayRange(meta.start, meta.end, t, now) });
    } else if (meta.type === DOCUMENT_META_TYPE.visit) {
        label = t('documents.meta.visit', { date: formatDayMonth(meta.date, t, now) });
    } else {
        const date = formatDayMonth(meta.date, t, now);
        label = meta.byPatient ? `${t('documents.meta.uploadedByYou')}${DOCUMENTS_META_SEPARATOR}${date}` : date;
    }

    return `${label}${DOCUMENTS_META_SEPARATOR}${t(`documents.fileKind.${item.fileKind}`)}`;
};
